<template>
  <div
    v-for="pack in packages"
    :key="pack.PackageId"
    class="group rounded-2xl hover-hover:hover:bg-brand hover-hover:hover:text-white flex items-center p-2 border cursor-pointer"
    :class="{
      'bg-accent text-brand': pack.PackageId === activePack.PackageId
    }"
    @click="selectPackage(pack)"
  >
    <h3
      v-text="pack.Title"
      class="hover-hover:group-hover:text-white text-2xl text-brand break-words"
      :class="{
        'text-brand': pack.PackageId === activePack.PackageId
      }"
    />
  </div>
</template>
<script>
import _ from "lodash";
export default {
  emits: ["update:activePack"],
  props: {
    activePack: Object
  },
  data: () => ({
    packages: Array
  }),
  created() {
    this.getPackages();
  },
  methods: {
    async getPackages() {
      try {
        const response = await this.axios.get(
          process.env.VUE_APP_PLUGIN_PACKAGE_API
        );
        this.packages = response.data.data.value;
        this.selectPackage(_.head(this.packages));
      } catch (error) {
        error;
      }
    },
    selectPackage(pack) {
      this.$emit("update:activePack", pack);
    }
  }
};
</script>
